import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
export interface StudyDesignTabSavingButtonsProps {
  isEditing: boolean;
  isSaveDisabled: boolean;
  onCancel: () => void;
  onSave: () => void;
  onEdit: () => void;
}

export default function StudyDesignTabSavingButtons(props: StudyDesignTabSavingButtonsProps): JSX.Element {
  return props.isEditing ? (
    <div>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={css(styles.button)}
        size={ButtonSize.MINI}
        text="Cancel"
        onClick={props.onCancel}
        disabled={false}
      />
      <Button
        buttonStyle={ButtonStyle.PRIMARY}
        className={css(styles.button)}
        size={ButtonSize.MINI}
        text="Save"
        onClick={props.onSave}
        disabled={props.isSaveDisabled}
      />
    </div>
  ) : (
    <Button
      icon="edit"
      buttonStyle={ButtonStyle.PRIMARY}
      className={css(styles.button)}
      size={ButtonSize.MINI}
      text="Edit"
      onClick={props.onEdit}
      disabled={false}
    />
  );
}

export const styles = StyleSheet.create({
  button: {
    marginLeft: '6px',
  },
});
